import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';

import formatUnreadCount from '~utils/formatUnreadCount';

const BADGE_FONT_SIZE_IN_PX = 11;
export const UNREAD_EMPHASIS_FONT_WEIGHT = 700;

// Fits a two-digit count at the badge font size; the pill is fully rounded at half its height.
const BADGE_HEIGHT_IN_PX = 18;

// Keeps a two-digit count clear of the pill's rounded ends.
const BADGE_SIDE_PADDING_IN_PX = 5;

type UnreadCountBadgeProps = {
  count: number;
  isMuted?: boolean;
};

export default function UnreadCountBadge({
  count,
  isMuted = false,
}: UnreadCountBadgeProps) {
  const theme = useTheme();

  if (count <= 0) return null;

  return (
    <Box
      aria-label={t('messaging.unread_count', { count })}
      component="span"
      data-test-id="messaging-unread-count-badge"
      sx={{
        alignItems: 'center',
        backgroundColor: isMuted
          ? theme.brandV2.colors.treadGray3
          : theme.brandV2.colors.treadRed,
        borderRadius: `${BADGE_HEIGHT_IN_PX / 2}px`,
        color: isMuted ? theme.semantic.textInverse : theme.palette.common.white,
        display: 'inline-flex',
        flexShrink: 0,
        fontSize: `${BADGE_FONT_SIZE_IN_PX}px`,
        fontWeight: UNREAD_EMPHASIS_FONT_WEIGHT,
        height: BADGE_HEIGHT_IN_PX,
        justifyContent: 'center',
        lineHeight: 1,
        minWidth: BADGE_HEIGHT_IN_PX,
        px: `${BADGE_SIDE_PADDING_IN_PX}px`,
      }}
    >
      {formatUnreadCount(count)}
    </Box>
  );
}
